import api from './api';
import { AuthResponse, User } from '../types';

export const authService = {
  register: async (username: string, email: string, password: string, fullName?: string, phone?: string, taothaoUsage?: string, zaloName?: string) => {
    try {
      const response = await api.post<{ 
        message: string; 
        email?: string;
        access_token?: string;
        user?: User;
        skip_verification?: boolean;
      }>('/auth/register', {
        username,
        email,
        password,
        full_name: fullName,
        phone: phone || undefined,
        taothao_usage: taothaoUsage || undefined,
        zalo_name: zaloName || undefined,
      });
      
      // TẠM THỜI: Nếu backend trả về access_token (bỏ qua xác thực email), tự động đăng nhập
      if (response.data.access_token) {
        localStorage.setItem('access_token', response.data.access_token);
        window.dispatchEvent(new Event('auth-changed'));
      }
      
      return response.data;
    } catch (error: any) {
      // Re-throw with better error message for 429
      if (error.response?.status === 429) {
        const errorData = error.response.data;
        error.response.data = {
          ...errorData,
          error: errorData.error || 'Bạn đã gửi quá nhiều yêu cầu. Vui lòng thử lại sau.',
        };
      }
      throw error;
    }
  },

  verifyEmail: async (email: string, code: string) => {
    const response = await api.post<AuthResponse>('/auth/verify-email', {
      email,
      code,
    });
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      window.dispatchEvent(new Event('auth-changed'));
    }
    return response.data;
  },

  resendVerification: async (email: string) => {
    const response = await api.post<{ message: string }>('/auth/resend-verification', {
      email,
    });
    return response.data;
  },

  login: async (username: string, password: string) => {
    const response = await api.post<AuthResponse>('/auth/login', {
      username,
      password,
    });
    if (response.data.access_token) {
      localStorage.setItem('access_token', response.data.access_token);
      // notify listeners (e.g., Navbar/useAuth) that auth state changed
      window.dispatchEvent(new Event('auth-changed'));
    }
    return response.data;
  },

  logout: () => {
    localStorage.removeItem('access_token');
    window.dispatchEvent(new Event('auth-changed'));
  },

  getCurrentUser: async () => {
    const token = localStorage.getItem('access_token');
    if (!token) {
      throw new Error('No token available');
    }
    
    try {
      const response = await api.get<{ user: User }>('/auth/me');
      return response.data.user;
    } catch (error: any) {
      // If token is invalid, clear it
      if (error.response?.status === 401 || error.response?.status === 422) {
        localStorage.removeItem('access_token');
      }
      throw error;
    }
  },

  isAuthenticated: (): boolean => {
    return !!localStorage.getItem('access_token');
  },

  getToken: (): string | null => {
    return localStorage.getItem('access_token');
  },

  forgotPassword: async (email: string) => {
    const response = await api.post<{ message: string; email?: string }>('/auth/forgot-password', {
      email,
    });
    return response.data;
  },

  verifyResetCode: async (email: string, code: string) => {
    const response = await api.post<{ message: string; email: string }>('/auth/verify-reset-code', {
      email,
      code,
    });
    return response.data;
  },

  resetPassword: async (email: string, code: string, newPassword: string) => {
    const response = await api.post<{ message: string }>('/auth/reset-password', {
      email,
      code,
      new_password: newPassword,
    });
    return response.data;
  },
};

